import api from "@/services/api";

const state = {
  data: null,
};

const mutations = {
  SET_OPENING_BALANCES(state, data) {
    state.data = data;
  },
};

const actions = {
  async getOpeningBalances({ commit }) {
    try {
      const res = await api.get("/opening-balances");
      commit("SET_OPENING_BALANCES", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching opening balances:", error.message);
      throw error;
    }
  },

  async setOpeningBalances({ dispatch }, payload) {
    try {
      const result = await api.put("/opening-balances", payload);
      await dispatch("getOpeningBalances");
      return result.data;
    } catch (error) {
      console.error("Error saving opening balances:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
